import { render, staticRenderFns } from "./ZinusBoardModal.vue?vue&type=template&id=41156f30"
import script from "./ZinusBoardModal.ts?vue&type=script&lang=ts&external"
export * from "./ZinusBoardModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports